export default __webpack_public_path__ + "static/media/carousel-tools.66ef038e.jpg";